export interface MedplumAppConfig {
    baseUrl?: string;
    ehrBaseUrl?: string;
    uploadResourceBaseUrl?: string;
    recaptchaSiteKey?: string;
    registerEnabled?: boolean | string;
    googleFitLambdaBaseUser?: string;
    dexcomLambdaBaseUrl?:string
    findFhirAppointment?:string
  }
  const config: MedplumAppConfig = {
    baseUrl: process.env?.REACT_APP_MEDPLUM_API_BASE_URL,
    ehrBaseUrl: process.env?.REACT_APP_EHR_LAMBDA_API_BASE_URL,
    uploadResourceBaseUrl: process.env?.REACT_APP_EHR_LAMBDA_API_BASE_URL,
    recaptchaSiteKey: process.env?.RECAPTCHA_SITE_KEY,
    registerEnabled: process.env?.MEDPLUM_REGISTER_ENABLED,
    googleFitLambdaBaseUser: process.env?.REACT_APP_GOOGLE_FIT_LAMBDA_API_URL,
    dexcomLambdaBaseUrl: process.env?.REACT_APP_DEXCOM_LAMBDA_API_URL,
    findFhirAppointment: process.env?.REACT_APP_FHIR_FIND_APPOINTMENT
  };
  
  export function getConfig(): MedplumAppConfig {
    return config;
  }
  
  export function isRegisterEnabled(): boolean {
    // Default to true
    return config.registerEnabled !== false && config.registerEnabled !== 'false';
  }
  